<p-card styleClass="flex w-full h-full p-4">
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center">
      <h2>Call Leaderboard</h2>
      <app-icon-button 
        [icon]="icons.solid.faArrowUpRightFromSquare" 
        [text]="false"
        textSize="text-sm"
        (onClick)="openExpandDialog()"
        pTooltip="Expand All Tables"
        tooltipPosition="top">
      </app-icon-button>
    </div>
  </ng-template>
  <div class="content">
    @if(loading()) {
    <div class="loading">
      Loading leaderboard data...
    </div>
    }
    @if (error()) {
    <div class="error">
      {{ error() }}
    </div>
  }
    <div *ngIf="!loading() && !error()" class="leaderboard-content">
      <!-- Main Tables -->
      <div class="grid grid-cols-3 gap-4">
        <!-- Week Table -->
        <div class="table-container">
          <h3>This Week</h3>
          <div class="h-full">
            <p-table [value]="weekTableData" [rows]="5" [paginator]="true" styleClass="p-datatable-sm">
              <ng-template #header>
                <tr>
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-header [column]="col"></app-table-header>
                  }
                </tr>
              </ng-template>
              <ng-template #body let-item>
                <tr [style.color]="isCurrentUser(item.id) ? 'rgb(232, 123, 38)' : null" [class.font-semibold]="isCurrentUser(item.id)">
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-column [column]="col" [data]="item"></app-table-column>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5" class="text-center p-4">
                    No calls so far this week... it could start with you!
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          @if(allTimeLoading()) {
          <div>Loading...</div>
          }
          @else {
          <div *ngIf="allTimeCallWeekData.length > 0" class="all-time-leader mt-3 p-3 bg-surface-100 dark:bg-surface-800 rounded">
            <div class="text-sm font-semibold mb-1">All Time Leader:</div>
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <span>{{allTimeCallWeekData[0].staffName}}</span>
                <span class="text-sm text-500">({{allTimeCallWeekData[0].week | date:'MMM d, yyyy'}})</span>
              </div>
              <span class="text-primary">{{allTimeCallWeekData[0].total}} calls</span>
            </div>
          </div>
          <button pButton label="View All Time" (click)="showAllTimeTable('Week')" class="p-button-text"></button>
          }
        </div>

        <!-- Month Table -->
        <div class="table-container">
          <h3>This Month</h3>
          <div class="h-full">
            <p-table [value]="monthTableData" [rows]="5" [paginator]="true" styleClass="p-datatable-sm">
              <ng-template #header>
                <tr>
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-header [column]="col"></app-table-header>
                  }
                </tr>
              </ng-template>
              <ng-template #body let-item>
                <tr [style.color]="isCurrentUser(item.id) ? 'rgb(232, 123, 38)' : null" [class.font-semibold]="isCurrentUser(item.id)">
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-column [column]="col" [data]="item"></app-table-column>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5" class="text-center p-4">
                    No calls so far this month... it could start with you!
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          @if(allTimeLoading()) {
          <div>Loading...</div>
          }
          @else {
          <div *ngIf="allTimeCallMonthData.length > 0" class="all-time-leader mt-3 p-3 bg-surface-100 dark:bg-surface-800 rounded">
            <div class="text-sm font-semibold mb-1">All Time Leader:</div>
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <span>{{allTimeCallMonthData[0].staffName}}</span>
                <span class="text-sm text-500">({{allTimeCallMonthData[0].month}})</span>
              </div>
              <span class="text-primary">{{allTimeCallMonthData[0].total}} calls</span>
            </div>
          </div>
          <button pButton label="View All Time" (click)="showAllTimeTable('Month')" class="p-button-text"></button>
          }
        </div>

        <!-- Year Table -->
        <div class="table-container">
          <h3>This Year</h3>
          <div class="h-full">
            <p-table [value]="yearTableData" [rows]="5" [paginator]="true" styleClass="p-datatable-sm">
              <ng-template #header>
                <tr>
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-header [column]="col"></app-table-header>
                  }
                </tr>
              </ng-template>
              <ng-template #body let-item>
                <tr [style.color]="isCurrentUser(item.id) ? 'rgb(232, 123, 38)' : null" [class.font-semibold]="isCurrentUser(item.id)">
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-column [column]="col" [data]="item"></app-table-column>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5" class="text-center p-4">
                    No calls so far this year... it could start with you!
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          @if(allTimeLoading()) {
          <div>Loading...</div>
          }
          @else {
          <div *ngIf="allTimeCallYearData.length > 0" class="all-time-leader mt-3 p-3 bg-surface-100 dark:bg-surface-800 rounded">
            <div class="text-sm font-semibold mb-1">All Time Leader:</div>
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <span>{{allTimeCallYearData[0].staffName}}</span>
                <span class="text-sm text-500">({{allTimeCallYearData[0].recordYear}})</span>
              </div>
              <span class="text-primary">{{allTimeCallYearData[0].total}} calls</span>
            </div>
          </div>

          <button pButton label="View All Time" (click)="showAllTimeTable('Year')" class="p-button-text"></button>
          }
        </div>

      </div>
    </div>
  </div>
</p-card>

<!-- All Time Dialog -->
<p-dialog [(visible)]="showAllTimeDialog" [style]="{width: '50vw'}"
  [header]="'All Time ' + currentDialogTable + ' Leaderboard'">
  <p-table [value]="currentDialogTable === 'Week' ? allTimeCallWeekData : 
                    currentDialogTable === 'Month' ? allTimeCallMonthData : 
                    allTimeCallYearData" styleClass="p-datatable-sm">
    <ng-template #header>
      <tr>
        @for (col of dialogColumns(); track col.field) {
        <app-table-header [column]="col"></app-table-header>
        }
      </tr>
    </ng-template>
    <ng-template #body let-data>
      <tr>
        @for (col of dialogColumns(); track col.field) {
        <app-table-column [column]="col" [data]="data"></app-table-column>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center p-4">
          No all-time {{currentDialogTable}} data available yet.
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- Expand Dialog -->
<p-dialog [(visible)]="showExpandDialog" [style]="{width: '95vw', height: '85vh'}"
  [header]="'Call Leaderboard - All Data'" [modal]="true" [closable]="true" [dismissableMask]="true">
  <div class="grid grid-cols-3 gap-4" style="max-height: 75vh; overflow-y: auto;">
    <!-- Week Table -->
    <div class="table-container">
      <div class="flex justify-between items-center mb-2">
        <h3>This Week</h3>
        <app-icon-button 
          [icon]="icons.ppmSolid.csv" 
          [text]="false"
          textSize="text-xs"
          (onClick)="exportTableCSV('week')"
          pTooltip="Export Week CSV"
          tooltipPosition="top">
        </app-icon-button>
      </div>
      <div style="max-height: 60vh; overflow-y: auto; padding-right: 8px;">
        <p-table [value]="weekTableData" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-header [column]="col"></app-table-header>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [style.color]="isCurrentUser(item.id) ? 'rgb(232, 123, 38)' : null" [class.font-semibold]="isCurrentUser(item.id)">
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-column [column]="col" [data]="item"></app-table-column>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center p-4">
                No calls so far this week... it could start with you!
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Month Table -->
    <div class="table-container">
      <div class="flex justify-between items-center mb-2">
        <h3>This Month</h3>
        <app-icon-button 
          [icon]="icons.ppmSolid.csv" 
          [text]="false"
          textSize="text-xs"
          (onClick)="exportTableCSV('month')"
          pTooltip="Export Month CSV"
          tooltipPosition="top">
        </app-icon-button>
      </div>
      <div style="max-height: 60vh; overflow-y: auto; padding-right: 8px;">
        <p-table [value]="monthTableData" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-header [column]="col"></app-table-header>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [style.color]="isCurrentUser(item.id) ? 'rgb(232, 123, 38)' : null" [class.font-semibold]="isCurrentUser(item.id)">
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-column [column]="col" [data]="item"></app-table-column>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center p-4">
                No calls so far this month... it could start with you!
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Year Table -->
    <div class="table-container">
      <div class="flex justify-between items-center mb-2">
        <h3>This Year</h3>
        <app-icon-button 
          [icon]="icons.ppmSolid.csv" 
          [text]="false"
          textSize="text-xs"
          (onClick)="exportTableCSV('year')"
          pTooltip="Export Year CSV"
          tooltipPosition="top">
        </app-icon-button>
      </div>
      <div style="max-height: 60vh; overflow-y: auto; padding-right: 8px;">
        <p-table [value]="yearTableData" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-header [column]="col"></app-table-header>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [style.color]="isCurrentUser(item.id) ? 'rgb(232, 123, 38)' : null" [class.font-semibold]="isCurrentUser(item.id)">
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-column [column]="col" [data]="item"></app-table-column>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center p-4">
                No calls so far this year... it could start with you!
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-dialog>